/**
 * Up pointing arrow .
 * Uses `currentColor`.
 */
export function ArrowUp({ className, width = '1em', height = '1em', ...rest }) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
			aria-hidden="true"
			className={className}
			{...rest}
      strokeWidth="2"
		>
      <path
        d="M12 20L12 4M12 4L18 10M12 4L6 10"
      />
		</svg>
	);
}

